<script lang="ts">
import { defineComponent, onMounted, provide, ref } from "vue";
import Logger from "js-logger";

export default defineComponent({
  name: "Home",
  components: {},
  watch: {
    $route(to) {
      document.title = to.meta.title || "GEV-Versicherung";
    },
  },
  setup() {
    const zeigeSpinner = ref(false);
    provide("zeigeSpinner", zeigeSpinner);

    const sichtbareElemente = ref(new Array<string>());

    function wechsleSichtbarkeit(element: string): void {
      Logger.debug("wechsleSichtbarkeit", element);
      if (sichtbareElemente.value.includes(element)) {
        sichtbareElemente.value = sichtbareElemente.value.filter((elem) => elem !== element);
      } else {
        sichtbareElemente.value.push(element);
      }
    }

    provide("wechsleSichtbarkeit", wechsleSichtbarkeit);

    function istSichtbar(element: string): boolean {
      return sichtbareElemente.value.includes(element);
    }

    provide("istSichtbar", istSichtbar);

    function feldBlurFocus(e: any, milliSec: number) {
      Logger.trace("Event: ", e);
      if (e.keyCode === 13) {
        return;
      } else {
        setTimeout(() => {
          e.target.blur();
          e.target.focus();
        }, milliSec);
      }
    }

    provide("feldBlurFocus", feldBlurFocus);

    onMounted(() => {
      // Bei inline-Aufruf in Maklerportal die automatische Maximierung deaktivieren, da
      // sich der Body ansonsten der Höhe des iFrames angleicht (3000px).
      if (document.URL.indexOf("inline=true") !== -1) {
        document.body.style.flexGrow = "0";
      }
    });

    return {
      zeigeSpinner,
    };
  },
});
</script>

<template>
  <div id="tarifrechner" :class="{ gevspinner__aktiv: zeigeSpinner }">
    <router-view />
    <div class="gevspinner">
      <div>
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="933.333"
          height="933.333"
          viewBox="0 0 700.000000 700.000000"
        >
          <path
            d="M179 77.8c-2 2-4 6.7-7.5 17.3-2.6 7.9-42.2 129.3-88.1 269.8C30 528.2.1 621.2.4 622.6c.4 1.3 1.9 2.6 3.7 3.3 2.3.8 75 1.1 257.1 1.1 278.9 0 258.9.5 262-6.1 2.2-4.5 176.8-539 176.8-541 0-.9-.8-2.3-1.8-3.2-1.7-1.6-21.1-1.7-259.1-1.7H181.8l-2.8 2.8zm189.2 159.9c24.9 24.9 26.8 27 26.8 30.3 0 3.3-4.8 8.3-88.7 92.2S217.3 449 214 449c-3.2 0-5.4-2-30.2-26.7-24.9-24.9-26.8-27-26.8-30.3 0-3.3 4.9-8.4 88.8-92.2C329.5 216 334.7 211 338 211c3.2 0 5.5 2 30.2 26.7zm100.7 103.2c25.9 26.3 47.5 48.9 48 50.2.5 1.4.5 3.4-.1 4.9-.5 1.4-12.7 14.3-27.1 28.7-22.8 22.9-26.6 26.3-29.2 26.3-1.6 0-3.7-.6-4.5-1.3-.8-.7-22.8-22.7-48.7-48.8-46-46.3-47.3-47.7-47.3-51.4 0-3.7 1-4.9 25.3-29.5 13.8-14.1 26.5-26.4 28.1-27.2 2.2-1.2 3.6-1.4 5.7-.6 1.6.6 22.2 20.7 49.8 48.7z"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
